import { z } from "zod";

export const variableSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string(),
  name: z.string().min(1),
  definition: z.string().min(1),
  description: z.string().nullable(),
  tags: z.array(z.string()).default([]),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type Variable = z.infer<typeof variableSchema>;

export const createVariableInputSchema = z.object({
  name: z.string().min(1),
  definition: z.string().min(1),
  description: z.string().optional(),
  tags: z.array(z.string()).optional(),
});

export type CreateVariableInput = z.infer<typeof createVariableInputSchema>;

export const updateVariableInputSchema = z.object({
  name: z.string().min(1).optional(),
  definition: z.string().min(1).optional(),
  description: z.string().nullable().optional(),
  tags: z.array(z.string()).optional(),
});

export type UpdateVariableInput = z.infer<typeof updateVariableInputSchema>;

export const listVariablesResponseSchema = z.object({
  data: z.array(variableSchema),
  nextCursor: z.string().uuid().optional(),
});

export type ListVariablesResponse = z.infer<typeof listVariablesResponseSchema>;
